import { getAPIFullUrl, getAxiosConfig, handleApiError, risapi } from './risapi'; // Assuming risapi is in the same folder

/**
 * Fetches the franchisee's current stock view.
 * @param {function} callback - Function to call with the response data or error.
 */
export const getStockView = async (callback) => {
    try {
        // Using the 'stock-view' endpoint
        const response = await risapi.get(getAPIFullUrl('/api/stock-view'), getAxiosConfig());
        
        if (response.status >= 200 && response.status < 300) {
             callback(response.data); // Contains { stock_view: [...] }
        } else {
             console.warn("Unexpected success status:", response.status, response.data);
             callback({ error: { message: `Unexpected status: ${response.status}` } });
        }
    } catch (error) {
        console.error("API Error in getStockView:", error);
        handleApiError(error); 
        callback({ error }); // Pass error object back
    }
};

// Exporting as a single object, similar to your OpeningBalancesAPI.js
export const stockApi = {
    getStockView
};